<template>
  <div class="contain pad-x pt-32 lg-pt-44 pb-72 lg-pb-96 bg-gradient">
    <h1 class="mb-24 lg-mb-28 fs-26 lg-fs-32 fw-800">Our Partners</h1>
    <div class="grid gap-y-40 gap-x-40 md-2s lg-3s">

      <div class="card-v2 pt-24 px-24 pb-48 grid gap-28 pt-20 justify-space partner"
        v-for="(partner, index) in partners" :key="`partner-${index}`">
        <div class="rel pt-60 md-pt-88 block">
          <img class="abs-center flex-auto partner-image" :src="partner.imageUrl" :alt="`${partner.name} logo`" />
        </div>

		<div>
			<p v-for="(paragraph, paragraphIndex) in toParagraphs(partner.description)"
			:key="`partner-${index}-description-${paragraphIndex}`">{{ paragraph }}</p>
		</div>

        <div class="mt-auto flex-col align-center gap-16" style="margin-top: auto;">
          <div v-if="partner.couponCode" class="text-center fs-14">
            <span class="mr-4 inline-block">Coupon Code:</span>
            <code class="ff-tenon fw-700 inline-block">{{ partner.couponCode }}</code>
            <span v-if="partner.couponCodeDescription">
              {{ partner.couponCodeDescription }}
            </span>
          </div>
          <a :href="partner.url" target="_blank" class="btn btn-purple">Visit Partner Site</a>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import {
  toParagraphs
} from '@/helpers/convert';
import partners from '@/helpers/partners';

export default {
  name: 'Resources',
  computed: {
    partners() {
      return partners;
    },
  },
  methods: {
    toParagraphs,
  },
  metaInfo: {
    title: 'Resources',
  },
};

</script>
